import { render, staticRenderFns } from "./new1.vue?vue&type=template&id=bd6c1270&"
import script from "./new1.vue?vue&type=script&lang=js&"
export * from "./new1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports